export default "__VITE_ASSET__ClRgvzPT__"